import * as React from 'react';
import px from 'prop-types';
import cx from 'classnames';
import { Translation } from 'Common/components/localization';
import LinkHint from './LinkHint';

const PRIVACY_URL = 'https://policies.google.com/privacy';
const TERMS_URL = 'https://policies.google.com/terms';

export default function RecaptchaDetails({ className }) {
    return (
        <p className={cx('RecaptchaDetails', className)}>
            <Translation id="Google.Recaptcha.Details" />{' '}
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
                <Translation id="Google.Recaptcha.PrivacyPolicy" />
                <LinkHint href={PRIVACY_URL} target="_blank" />
            </a>
            {'/ '}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
                <Translation id="Google.Recaptcha.TermsOfService" />
                <LinkHint href={TERMS_URL} target="_blank" />
            </a>
        </p>
    );
}

RecaptchaDetails.propTypes = {
    className: px.string,
};
